var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { attrs: { id: "Return_Bar" } }, [
      _c("i", { staticClass: "el-icon-arrow-left" }),
      _vm._v(" "),
      _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
        _vm._v("返回")
      ]),
      _vm._v(" "),
      !_vm.urlLink
        ? _c(
            "a",
            {
              staticStyle: {
                position: "absolute",
                top: "9px",
                right: "20px",
                "z-index": "9"
              },
              attrs: {
                target: "_blank",
                href:
                  _vm.imUrl +
                  "/TJ_TJK_IMAction.html?token=" +
                  _vm.imToken +
                  "&tjkId=" +
                  _vm.tjkInfo.id +
                  "&userName=" +
                  _vm.tjkInfo.realName +
                  "&tjkNumber=" +
                  _vm.tjkInfo.tjkNum +
                  "&platform=assitant"
              }
            },
            [
              _c("img", {
                staticStyle: { height: "30px" },
                attrs: { src: require("@/assets/images/zx.png"), alt: "" }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "text" } },
      [
        _vm._l(_vm.courseList, function(c, key) {
          return !_vm.urlLink
            ? _c("div", { key: key, staticClass: "step-list" }, [
                _c("div", { staticClass: "step-list_top" }, [
                  _c("div", { staticClass: "list_top_left" }, [
                    _c(
                      "div",
                      {
                        staticClass: "circle",
                        class: {
                          circle: c.passState == "Passed",
                          othercircle:
                            c.passState == "Ongoing" || c.passState == null
                        }
                      },
                      [
                        _vm.courseList.length != 1
                          ? _c("div", [_vm._v(_vm._s(key + 1))])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(
                      "\n            " +
                        _vm._s(c.knowledge.title) +
                        "\n            "
                    ),
                    _c(
                      "div",
                      { class: c.passState == "Passed" ? "isgreen" : "isred" },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              c.passState == "Passed" && c.passState != null
                                ? "已完成"
                                : "未完成"
                            ) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "step-list_under2",
                      domProps: { innerHTML: _vm._s(c.knowledge.description) }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "list_top_right",
                      staticStyle: { width: "200px" }
                    },
                    [
                      c.passState == null
                        ? _c("div", { staticClass: "lock" })
                        : _c(
                            "div",
                            [
                              c.knowledgeType != "Special"
                                ? _c("div", [
                                    c.passState == "Ongoing"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "spb_button",
                                            attrs: {
                                              type: "primary",
                                              size: "small"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.goKnowledge(c, key)
                                              }
                                            }
                                          },
                                          [_vm._v("点击学习")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    c.passState == "Passed"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "spb_button",
                                            attrs: {
                                              type: "primary",
                                              size: "small"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.goKnowledge(c, key)
                                              }
                                            }
                                          },
                                          [_vm._v("重新学习")]
                                        )
                                      : _vm._e()
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              c.knowledgeType == "Special"
                                ? [
                                    c.knowledge.assitantType == "downLink"
                                      ? [
                                          c.passState != "Passed" &&
                                          c.knowledge.assitantType ==
                                            "downLink" &&
                                          c.knowledge.downLink
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "spb_button",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.goDownLoadLink(
                                                        c.knowledge
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("点击下载")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.passState == "Passed" &&
                                          c.knowledge.assitantType ==
                                            "downLink" &&
                                          c.knowledge.downLink
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "spb_button",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.goDownLoadLink(
                                                        c.knowledge
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("重新下载")]
                                              )
                                            : _vm._e()
                                        ]
                                      : [
                                          [
                                            "fbt",
                                            "fbtoperate",
                                            "primary",
                                            "middle",
                                            "high",
                                            "aftersaleprimary",
                                            "aftersalemiddle",
                                            "aftersalehigh"
                                          ].includes(c.knowledge.assitantType)
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "sp_button",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.Gorecord(
                                                        c.knowledge
                                                          .assitantType,
                                                        c.knowledge
                                                          .businessMajorId
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("练习记录")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.knowledge.assitantType.endsWith(
                                            "exam"
                                          ) ||
                                          c.knowledge.assitantType.endsWith(
                                            "primary"
                                          ) ||
                                          c.knowledge.assitantType.endsWith(
                                            "middle"
                                          ) ||
                                          c.knowledge.assitantType.endsWith(
                                            "high"
                                          )
                                            ? [
                                                c.passState == "Ongoing"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "spb_button",
                                                        attrs: {
                                                          type: "primary",
                                                          size: "small"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.GoPracticalOperation(
                                                              c.knowledge,
                                                              c.knowledge
                                                                .businessMajorId,
                                                              _vm.courseId,
                                                              key,
                                                              c.knowledge.title
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("点击练习")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                c.passState == "Passed"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "spb_button",
                                                        attrs: {
                                                          type: "primary",
                                                          size: "small"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.GoPracticalOperation(
                                                              c.knowledge,
                                                              c.knowledge
                                                                .businessMajorId,
                                                              _vm.courseId,
                                                              key,
                                                              c.knowledge.title
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("重新练习")]
                                                    )
                                                  : _vm._e()
                                              ]
                                            : [
                                                c.passState == "Ongoing"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "spb_button",
                                                        attrs: {
                                                          type: "primary",
                                                          size: "small"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.GoPracticalOperation(
                                                              c.knowledge,
                                                              c.knowledge
                                                                .businessMajorId,
                                                              _vm.courseId,
                                                              key,
                                                              c.knowledge.title
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("点击学习")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                c.passState == "Passed"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "spb_button",
                                                        attrs: {
                                                          type: "primary",
                                                          size: "small"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.GoPracticalOperation(
                                                              c.knowledge,
                                                              c.knowledge
                                                                .businessMajorId,
                                                              _vm.courseId,
                                                              key,
                                                              c.knowledge.title
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("重新学习")]
                                                    )
                                                  : _vm._e()
                                              ]
                                        ]
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                    ]
                  )
                ]),
                _vm._v(" "),
                key != 0
                  ? _c("div", {
                      staticClass: "top_line",
                      class: {
                        top_isCheck:
                          c.passState == "Passed" || c.passState == "Ongoing",
                        top_noCheck: c.passState == null
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.courseList.length > 1 && key != _vm.courseList.length - 1
                  ? _c("div", {
                      class: {
                        line: c.passState == "Passed",
                        otherline:
                          c.passState == "Ongoing" || c.passState == null
                      }
                    })
                  : _vm._e()
              ])
            : _vm._e()
        }),
        _vm._v(" "),
        _vm.urlLink
          ? _c("div", [
              _c("iframe", {
                staticClass: "iframe-container",
                attrs: { src: _vm.urlLink, scrolling: "auto", frameborder: "0" }
              })
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01580b54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01580b54","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/newservice/Secondarylist.vue
// module id = 1630
// module chunks = 0